// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__188_Z","content":"styles_content__2viDw","selectAll":"styles_selectAll__3-vv7"};